<template>
	<li class="message-item f-clearfix" :style="{
	'margin-bottom': setMarginBottom,
	'line-height': setLineHeight
	}">
		<div class="message-l f-left" :style='{
			"width":setSize + "em",
			"color": setColor
		}'>
			{{title}}
		</div>
		<div class="message-r f-block" :style='{"color": setColor}'>
			<slot></slot>
		</div>
	</li>
</template>
<script>
	export default {
		name:'message-item',
		props:['title','size','lineHeight','marginBottom','color'],
		inject:['meList'],
		computed:{
			setSize(){
				let me = this
				return me.size || me.meList.size
			},
			setLineHeight(){
				let me = this;
				return me.lineHeight || me.meList.lineHeight
			},
			setMarginBottom(){
				let me = this;
				return me.marginBottom || me.meList.marginBottom || '10px'
			},
			setColor(){
				let me = this;
				return me.color || me.meList.color
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/message-item.vue